
import { ReactNode, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/auth/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import logger from "@/utils/logger";

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { theme } = useThemeConfig();

  const searchParams = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(
    location.hash.startsWith("#") ? location.hash.slice(1) : location.hash,
  );
  const type = searchParams.get("type") || hashParams.get("type");

  // Redirect to reset password page if the link contains recovery parameters
  if (type === "recovery") {
    return (
      <Navigate
        to={`/reset-password${location.search}${location.hash}`}
        replace
      />
    );
  }

  useEffect(() => {
    logger.log("[PROTECTED_ROUTE] user:", user);
    logger.log("[PROTECTED_ROUTE] isLoading:", isLoading);
  }, [user, isLoading]);
  
  // If authentication is still loading, show nothing or a loading indicator
  if (isLoading) {
    return (
      <div
        className="flex min-viewport-height items-center justify-center"
        style={{ backgroundColor: theme.backgroundColor }}
      >
        <span className="animate-pulse" style={{ color: theme.sectionTextColor }}>
          Caricamento in corso...
        </span>
      </div>
    );
  }

  // If no user is logged in, redirect to login page
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is authenticated, render the children wrapped in AppLayout
  return (
    <AppLayout>
      {children}
    </AppLayout>
  );
};
